/* Utility Function - Open and accordions */

/* Trigger Class = "accordion" */
/* Content must be next direct sibling, with the class "accordion__content" */
var accordion = document.getElementsByClassName("accordion");

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", function() {
    var content = this.nextElementSibling;
    this.classList.toggle("open");
    content.classList.toggle("open");

    if (content.style.maxHeight){
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "+"
      setTimeout(() => {
      content.style.maxHeight = null;
      content.classList.remove('has-opened');
      }, 1);
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "-"
      setTimeout(() => {
        content.style.maxHeight = "none";
        content.classList.add('has-opened');
      }, 200);
    } 
  });
}

/* Utility Function - Freeze Body */
freezeBodyToggle = () => {
  body = document.querySelector('body');

  if (body.classList.contains('freezeBody')) {
    body.classList.remove('freezeBody');
  } else if (!body.classList.contains('freezeBody')) {
    body.classList.add('freezeBody');
  }
}

/* Stores Product Form Headers */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}